"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetTime = void 0;
const resetTime = (date) => {
    const newDate = new Date(date);
    newDate.setUTCHours(0, 0, 0, 0);
    return newDate;
};
exports.resetTime = resetTime;
//# sourceMappingURL=resetTime.js.map